function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FBCA1C;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "BACKGROUND_DON_xB4_T_PRINT"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "GRAPHIC"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M65.4,20.5c0.6,0,0.9,0.4,0.9,0.9l-0.9,9.6c-0.1,0.5-0.6,0.9-1,0.9h-8.1V63c0,0.4-0.4,0.9-0.9,0.9H44.2 c-0.5,0-0.9-0.4-0.9-0.9V31.8h-9.2c-0.4,0-0.9-0.4-0.9-0.9v-9.5c0-0.5,0.4-0.9,0.9-0.9H65.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M103.6,20.5c0.6,0,0.9,0.4,0.9,0.9V63c0,0.4-0.4,0.9-0.9,0.9H91.8c-0.5,0-0.9-0.4-0.9-0.9V48.9h-8.8V63 c0,0.4-0.4,0.9-0.9,0.9H69.4c-0.4,0-0.9-0.4-0.9-0.9V21.4c0-0.5,0.4-0.9,0.9-0.9h11.8c0.6,0,0.9,0.4,0.9,0.9v16.4h8.8V21.4 c0-0.5,0.4-0.9,0.9-0.9H103.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M138.1,52.5c0.5,0,0.9,0.4,0.9,0.8V63c0,0.4-0.4,0.9-0.9,0.9h-28c-0.4,0-0.9-0.5-1-0.9V21.3 c0-0.6,0.3-0.9,0.9-0.9h27.7c0.6,0,1,0.4,1,0.9v9.5c0,0.6-0.4,0.9-1,0.9h-15.5v5h14.3c0.6,0,0.9,0.4,0.8,0.8l-0.9,8.8 c-0.1,0.4-0.5,0.8-1.1,0.8h-13.2v5.3H138.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M179.3,20.5c0.6,0,0.9,0.4,0.9,0.9V63c0,0.4-0.4,0.9-0.9,0.9h-10.9c-0.4,0-1-0.3-1.3-0.8l-10.9-19.6V63 c0,0.4-0.4,0.9-0.9,0.9H144c-0.5,0-0.9-0.4-0.9-0.9V21.4c0-0.5,0.4-0.9,0.9-0.9h10.9c0.6,0,1.2,0.3,1.4,0.8l10.9,19.6V21.4 c0-0.5,0.4-0.9,0.9-0.9H179.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M226.2,63c0.2,0.4-0.1,0.8-0.6,0.8h-12.5c-0.6,0-1.1-0.3-1.3-0.8l-1.9-6.6h-11.8l-1.9,6.6 c-0.3,0.5-0.8,0.8-1.3,0.8h-12.5c-0.5,0-0.8-0.4-0.6-0.8l14.2-41.8c0.2-0.4,0.9-0.8,1.5-0.8h12.8c0.6,0,1.3,0.4,1.5,0.8L226.2,63z  M204,35.5l-3.4,12h6.8L204,35.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M230.3,51.1c0.3-0.6,0.8-0.8,1.2-0.5c3.1,2,6.9,3.4,9.2,3.4c1.8,0,3-0.9,3-2.2c0-5.6-17.8-3.5-17.8-18.3 c0-8.4,6.4-14,15.9-14c4.8,0,10.4,1.9,14.1,4.7c0.3,0.3,0.4,0.6,0.3,1l-4.3,7.7c-0.3,0.6-0.8,0.8-1.2,0.5c-2.9-1.6-6.2-2.7-8.3-2.7 c-1.8,0-3.1,0.9-3.1,2.3c0,4.8,17.8,2.5,17.8,17.8c0,8.4-6.5,14-16.2,14c-4.7,0-10.3-1.9-14-4.7c-0.3-0.3-0.4-0.6-0.3-1L230.3,51.1 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M294.9,60c0.2,0.4-0.1,0.8-0.6,1.1c-3,2.2-8.2,3.6-13.2,3.6c-12,0-21.6-10.1-21.6-22.6 c0-12.5,9.7-22.6,21.6-22.6c5,0,10.3,1.4,13.2,3.6c0.5,0.4,0.8,0.7,0.6,1.1l-4,8.4c-0.3,0.6-0.7,0.8-1.2,0.5 c-2.3-1.3-4.6-1.8-7.3-1.8c-5.3,0-9.6,4.8-9.6,10.8c0,5.9,4.3,10.8,9.6,10.8c2.7,0,5-0.4,7.3-1.8c0.5-0.3,0.9-0.1,1.2,0.5L294.9,60 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M340.8,42.1c0,13.6-9.1,22.6-22.6,22.6c-13.6,0-22.6-9.1-22.6-22.6c0-13.6,9.1-22.6,22.6-22.6 C331.7,19.4,340.8,28.5,340.8,42.1z M308.6,42.2c0,6.2,3.8,10.4,9.6,10.4s9.6-4.2,9.6-10.4c0-6.2-3.8-10.4-9.6-10.4 S308.6,35.9,308.6,42.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M393.1,20.5c0.5,0,0.9,0.4,0.9,0.9V63c0,0.4-0.4,0.9-0.9,0.9h-11.6c-0.5,0-0.9-0.4-0.9-0.9V44.5l-6.4,18.4 c-0.2,0.6-0.8,0.9-1.3,0.9h-7.4c-0.6,0-1.1-0.4-1.3-0.9l-6.4-18.4V63c0,0.4-0.4,0.9-0.9,0.9h-11.6c-0.5,0-0.9-0.4-0.9-0.9V21.4 c0-0.5,0.4-0.9,0.9-0.9h15c0.8,0,1.6,0.5,1.8,1.3l7.2,23.6l7.2-23.6c0.2-0.8,0.9-1.3,1.8-1.3H393.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M414.3,20.5c11,0,17.6,6,17.6,15s-6.6,15-17.6,15h-2.6V63c0,0.4-0.4,0.9-1,0.9h-11.3c-0.4,0-0.9-0.4-0.9-0.9 V21.4c0-0.5,0.4-0.9,0.9-0.9H414.3z M414.8,39.1c2.2,0,3.7-1.5,3.7-3.7c0-2.2-1.5-3.7-3.7-3.7h-3.3v7.4H414.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M471.6,63c0.2,0.4-0.1,0.8-0.6,0.8h-12.5c-0.6,0-1.1-0.3-1.3-0.8l-1.9-6.6h-11.8l-1.9,6.6 c-0.3,0.5-0.8,0.8-1.3,0.8h-12.5c-0.5,0-0.8-0.4-0.6-0.8l14.2-41.8c0.2-0.4,0.9-0.8,1.5-0.8h12.8c0.6,0,1.3,0.4,1.5,0.8L471.6,63z  M449.4,35.5l-3.4,12h6.8L449.4,35.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M509.4,20.5c0.6,0,0.9,0.4,0.9,0.9V63c0,0.4-0.4,0.9-0.9,0.9h-10.9c-0.4,0-1-0.3-1.3-0.8l-10.9-19.6V63 c0,0.4-0.4,0.9-0.9,0.9h-11.1c-0.5,0-0.9-0.4-0.9-0.9V21.4c0-0.5,0.4-0.9,0.9-0.9H485c0.6,0,1.2,0.3,1.4,0.8l10.9,19.6V21.4 c0-0.5,0.4-0.9,0.9-0.9H509.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M551.9,20.5c0.6,0,1,0.4,0.7,1l-14.3,22.8V63c0,0.4-0.4,0.9-0.9,0.9h-11.1c-0.5,0-0.9-0.4-0.9-0.9V44.3 l-14.3-22.8c-0.3-0.6,0.1-1,0.7-1h13.5c0.6,0,1.2,0.4,1.4,1l5.2,10.1l5.2-10.1c0.3-0.6,0.8-1,1.4-1H551.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M558.1,64.7c-3.3,0-5.5-2.1-5.5-5.2c0-3.1,2.2-5.3,5.5-5.3c3.3,0,5.5,2.1,5.5,5.3 C563.6,62.7,561.4,64.7,558.1,64.7z"
}));

var SvgThenascompany = function SvgThenascompany(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.3 83.8",
    style: {
      enableBackground: "new 0 0 595.3 83.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThenascompany, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thenascompany.540d2ff4.svg";
export { ForwardRef as ReactComponent };